import React from "react";
import TiktokSosmed from "./TiktokSosmed";

const TiktokMain = () => {
  return (
    <section id="tiktok" className="pt-12">
      <div className="">
        <TiktokSosmed />
      </div>
    </section>
  );
};

export default TiktokMain;
